import React from "react";
import { useNavigate } from "react-router-dom";
import "./Css/View.css";
import profile from "./Images/Dark Blue and Gold  Circle Logo 1 (1).png"

const Setting = () => {
        const navigate = useNavigate();
        const handleEditClick = (index) => {
  navigate("/dashboard/settingedit"); 
};

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3    style={{ cursor: "pointer" }}
        onClick={() => navigate(-1)}>
        <span>सेटिंग्ज</span>
        </h3>
        <button className="edit-btn" onClick={() => handleEditClick()} >एडिट करा</button>
      </div>

    <h2>प्रोफाइल</h2>
      <div className="profile-card">
        <img
          src={profile}
          alt="student"
          className="profile-img"
        />
        <p className="updated-text">Last Updated 12/12/2024</p>
      </div>

      {/* Info Grid */}
      <div className="info-grid">
        <div className="info-box">
          <label>सुपर अडमिन नाव</label>
          <p>AKES</p>
        </div>
        <div className="info-box">
          <label>मोबाईल नं.</label>
          <p>९८७६५४३२१०</p>
        </div>
         <div className="info-box">
          <label>ईमेल</label>
          <p>gnyandeepenglishschool@gmail.com</p>
        </div>
          <div className="info-box">
          <label>वेबसाइट</label>
          <p>www.gyandeepschool.in</p>
        </div>

      </div>

      <h2>पत्ता व ठिकाण विभाग</h2>
      <div className="info-grid">
       
   <div className="info-box">
          <label>पत्ता</label>
          <p>ज्ञानदीप रोड</p>
        </div>
         <div className="info-box">
          <label>शहर</label>
          <p>सातारा </p>
        </div>
         <div className="info-box">
          <label>जिल्हा</label>
          <p>सातारा </p>
        </div>
      </div>
    </div>
  );
};

export default Setting;
